import React, { useState, useEffect } from 'react';
import { CModal, CModalHeader, CModalBody, CModalTitle } from '@coreui/react';
import { FaPodcast, } from "react-icons/fa";
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import '../../assets/css/mainstyle.css';
import api from '../../service/caller';
import { getUserIdFromToken } from '../../utils/authUtils';
import { CountrySelect, StateSelect, CitySelect } from "react-country-state-city";
import "react-country-state-city/dist/react-country-state-city.css";
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import modal from '../../assets/images/modal.png';
import { Modal, Button } from 'react-bootstrap';

const AddLocation = ({ closeModal }) => {
    const [visible, setVisible] = useState(true);

    // Fonction pour fermer le modal
    const handleClose = () => {
        setVisible(false);
        closeModal();
    };

    const [showaddressModal, setShowAddressModal] = useState(false);
    const [clinicName, setClinicName] = useState('');
    const [clinicAddress, setClinicAddress] = useState('');
    const [country, setCountry] = useState(null);
    const [currentState, setCurrentState] = useState(null);
    const [currentCity, setCurrentCity] = useState(null);
    const [currency, setCurrency] = useState(null);
    const [telephone1, setTelephone1] = useState(''); // Téléphone 1
    const [telephone2, setTelephone2] = useState(''); // Téléphone 2
    const [errors, setErrors] = useState({});
    const [showToast, setShowToast] = useState(false);

    // Ouvrir et fermer le modal
    const handleInputClick = () => setShowAddressModal(true);
    const handleCloseInputModal = () => setShowAddressModal(false);

    const handleSaveAddress = () => {
        const address = `${country?.name}, ${currentCity?.name}, ${currentState?.name}`;
        setClinicAddress(address);
        handleCloseInputModal();
    };


    // Soumission du formulaire
    const handleSubmit = async (e) => {
        e.preventDefault();

        // Données du formulaire
        const selectedCountry = country?.name;
        const selectedCity = currentCity?.name;
        const selectedDepartment = currentState?.name;

        const formData = {
            hospital_name: clinicName,
            hospital_country: selectedCountry,
            hospital_city: selectedCity,
            hospital_state_province: selectedDepartment,
            hospital_phone: telephone1,
            hospital_phone2: telephone2,
            hospital_currency: currency

        };

        try {
            // Récupérez le token depuis le localStorage
            const token = localStorage.getItem('access_token');
            if (!token) {
                throw new Error('Session expired. Please log in again.');
            }

            // Effectuez la requête à l'API
            const response = await api.post('/api/addhospital', formData, {
                headers: {
                    'Authorization': `Bearer ${token}`, // Ajoutez le token dans l'en-tête
                    'Content-Type': 'application/json',
                },
            });

            // Si la requête réussit
            toast.success('Hospital added successfully!');
            setTimeout(() => {
                handleClose(); // ou navigate()
            }, 1500);
        } catch (error) {
            // Gestion des erreurs
            if (error.response?.status === 401) {
                toast.error('Session expired. Redirecting to login...');
                localStorage.removeItem('access_token'); // Supprimez le token
                window.location.href = '/login'; // Redirigez l'utilisateur
            } else {
                const errorMessage = error.response?.data?.error || error.message || 'An unknown error occurred.';
                toast.error(`Error: ${errorMessage}`);
            }
        }
    };

    return (
        <>
            <ToastContainer />
            <CModal className='newregistermodal'
                alignment="center"
                scrollable
                size='lg'
                visible={visible}
                onClose={handleClose}
                aria-labelledby="VerticallyCenteredScrollableExample2">
                <CModalHeader>
                    <CModalTitle>Register new patient</CModalTitle>
                </CModalHeader>
                <CModalBody>
                    <div className="girla ">
                        <div className="p-4 mt-5 border rounded bg-light">
                            {/* Contenu affiché lorsque le dropdown est ouvert */}
                            <form onSubmit={handleSubmit} >
                                <div className="mb-3 manga">
                                    <label className="">Enter hospital name</label>
                                    <input
                                        type="text"
                                        name="clinicName"
                                        className="form-control teletoon"
                                        placeholder='Clinique name'
                                        value={clinicName}
                                        onChange={(e) => setClinicName(e.target.value)}
                                        required
                                    />
                                </div>
                                <div className="mb-5">
                                    <div className="input-group">
                                        <input type="text" className="form-control teletoon" placeholder="Clinic's address"
                                            value={clinicAddress}
                                            onClick={handleInputClick}
                                            readOnly />
                                        {/* <span className="input-group-text">📍</span> */}
                                    </div>
                                </div>
                                <div className="d-flex justify-content-between mb-3 mt-2 phonefield">
                                    <div className="form-floating mb-3 flex-fill me-2">
                                        <PhoneInput
                                            country={'bj'}
                                            value={telephone1}
                                            onChange={(phone) => setTelephone1(phone)}
                                            inputClass="form-control geste w-100"  // Ajout de w-100 pour le rendre uniforme
                                            placeholder="Telephone 1"
                                        />
                                        {errors.telephone1 && <span className="error">{errors.telephone1}</span>}
                                    </div>
                                    <div className="form-floating mb-3 flex-fill ms-2">
                                        <PhoneInput
                                            country={'bj'}
                                            value={telephone2}
                                            onChange={(phone) => setTelephone2(phone)}
                                            inputClass="form-control geste w-100"  // Ajout de w-100 pour le rendre uniforme
                                            placeholder="Telephone 2"
                                        />
                                        {errors.telephone2 && <span className="error">{errors.telephone2}</span>}
                                    </div>
                                </div>

                                {/* Devise */}
                                <div className="form-floating mb-3 mt-2 col-12">
                                    <select
                                        className="form-control"
                                        value={currency}
                                        onChange={(e) => setCurrency(e.target.value)}
                                    >
                                        <option value="">Select Currency</option>
                                        <option value="USD">USD</option>
                                        <option value="EUR">EUR</option>
                                        <option value="GBP">GBP</option>
                                        <option value="XOF">XOF</option>
                                        {/* Ajouter d'autres devises ici */}
                                    </select>
                                    {errors.currency && <span className="error">{errors.currency}</span>}
                                </div>

                                <div className="text-end">
                                    <button className="btn btn soglo" type='submit'>
                                        Save <span>&#x2192;</span>
                                    </button>
                                </div>
                            </form>
                            {/* Modal Toast for successful hospital register */}
                            <Modal
                                show={showToast}
                                onHide={() => setShowToast(false)}
                                centered
                                backdrop="static"
                                keyboard={false}
                            >
                                <div className="text-center p-4">
                                    {/* Style pour l'en-tête */}
                                    <div
                                        style={{
                                            backgroundColor: "#d4edda",
                                            color: "#155724",
                                            padding: "10px",
                                            borderRadius: "8px 8px 0 0",
                                        }}
                                    >
                                        <h5 className="fw-bold">SUCCESS</h5>
                                    </div>
                                    {/* Image */}
                                    <div className="mt-3">
                                        <img
                                            src={modal} // Utilisez l'import ici
                                            alt="Success"
                                            style={{ width: "300px", height: "200px", }}
                                        />

                                    </div>
                                    {/* Texte */}
                                    <div className="mt-3">
                                        <h6 className="fw-bold">Hospital's site created successfully</h6>
                                    </div>
                                </div>
                            </Modal>

                            {/* Modal Bootstrap */}
                            <Modal show={showaddressModal} onHide={handleCloseInputModal} centered>
                                <Modal.Header closeButton>
                                    <Modal.Title>Address <FaPodcast className="dill" /></Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                    {/* Pays */}
                                    <div className="form-group w-100 custom-select-container mb-3">
                                        {/* Country Select */}
                                        <CountrySelect
                                            containerClassName="custom-select"
                                            onChange={(_country) => setCountry(_country)}
                                            placeHolder="Select Country"
                                        />
                                        {errors.country && <span className="error">{errors.country}</span>}
                                    </div>

                                    <div className="form-group w-100 custom-select-container mb-3">
                                        {/* State Select */}
                                        <StateSelect
                                            countryid={country?.id}
                                            containerClassName="custom-select"
                                            onChange={(_state) => setCurrentState(_state)}
                                            placeHolder="Select State"
                                        />
                                        {errors.currentState && <span className="error">{errors.currentState}</span>}
                                    </div>

                                    <div className="form-group w-100 custom-select-container mb-3">
                                        {/* City Select */}
                                        <CitySelect
                                            countryid={country?.id}
                                            containerClassName="custom-select"
                                            stateid={currentState?.id}
                                            onChange={(_city) => setCurrentCity(_city)}
                                            placeHolder="Select City"
                                        />
                                        {errors.currentCity && <span className="error">{errors.currentCity}</span>}
                                    </div>

                                </Modal.Body>
                                <Modal.Footer>
                                    <Button
                                        variant="primary"
                                        onClick={handleSaveAddress}
                                        disabled={!country || !currentCity || !currentState}
                                    >
                                        Save changes
                                    </Button>
                                </Modal.Footer>
                            </Modal>
                        </div>
                    </div>
                </CModalBody>
            </CModal>
        </>

    );
};

export default AddLocation;
